import { render, staticRenderFns } from "./c-rate.vue?vue&type=template&id=65068d56&scoped=true"
import script from "./c-rate.vue?vue&type=script&lang=js"
export * from "./c-rate.vue?vue&type=script&lang=js"
import style0 from "./c-rate.vue?vue&type=style&index=0&id=65068d56&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65068d56",
  null
  
)

export default component.exports